export default "__VITE_ASSET__1a232579__"